export default "__VITE_ASSET__CiRbREaH__"